export default {
  root: "",
  login: "login",
};
